import { serializeMeasurementAttributeValue } from "./measurementAttribute";

export function parseEagleViewFeet(value: unknown): number {
    if (typeof value !== "string" && typeof value !== "number") return 0;
    const cleaned = String(value).replace(/[^\d.]/g, "");
    return parseFloat(cleaned) || 0;
}

function formatPitchLabel(pitch: unknown): string {
    const raw = String(pitch ?? "").trim();
    if (!raw) return "";
    if (/\d+\s*\/\s*\d+/.test(raw)) return raw.replace(/\s+/g, "");
    const num = Number(raw);
    if (!Number.isNaN(num) && num > 0) return `${num}/12`;
    return raw;
}

/** Build roof measurement attributes in the new `{Calculated,Actual}` JSON format. */
export function buildRoofMeasurementAttributes(totalMeasurements: {
    AreaValue?: unknown;
    LengthRidge?: unknown;
    LengthHip?: unknown;
    LengthValley?: unknown;
    LengthEave?: unknown;
    LengthRake?: unknown;
    LengthStepFlashing?: unknown;
    LengthStep?: unknown;
}): Record<string, string> {
    return {
        Area: serializeMeasurementAttributeValue({
            Calculated: parseEagleViewFeet(totalMeasurements.AreaValue),
        }),
        Ridge: serializeMeasurementAttributeValue({
            Calculated: parseEagleViewFeet(totalMeasurements.LengthRidge),
        }),
        Hip: serializeMeasurementAttributeValue({
            Calculated: parseEagleViewFeet(totalMeasurements.LengthHip),
        }),
        Valley: serializeMeasurementAttributeValue({
            Calculated: parseEagleViewFeet(totalMeasurements.LengthValley),
        }),
        Eave: serializeMeasurementAttributeValue({
            Calculated: parseEagleViewFeet(totalMeasurements.LengthEave),
        }),
        Rake: serializeMeasurementAttributeValue({
            Calculated: parseEagleViewFeet(totalMeasurements.LengthRake),
        }),
        StepFlashing: serializeMeasurementAttributeValue({
            Calculated: parseEagleViewFeet(totalMeasurements.LengthStepFlashing ?? totalMeasurements.LengthStep),
        }),
    };
}

/**
 * Map EagleView PitchTable into the Initial Inspection `RoofPitch` shape:
 * `[{ Name, Pitch, Squares }]` where `Squares` stores **square feet** (SF),
 * matching EagleView PitchTable.Area.
 */
export function buildRoofPitchAttributeFromPitchTable(pitchTable: unknown): string | null {
    if (!Array.isArray(pitchTable) || pitchTable.length === 0) return null;

    const slopes = pitchTable.map((entry: any, idx: number) => {
        const areaSqft = parseEagleViewFeet(entry?.Area);

        return {
            Name: pitchTable.length === 1 ? "Main" : `Area ${idx + 1}`,
            Pitch: formatPitchLabel(entry?.Pitch),
            Squares: areaSqft > 0 ? String(areaSqft) : "",
        };
    });

    return JSON.stringify(slopes);
}
